var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.356 21.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M490.733,72.529a8.047,8.047,0,0,1,.977.064,1.951,1.951,0,0,1,1.6,1.943q0,4.355,0,8.711a1.979,1.979,0,0,1-2,2c-1.085.007-2.169,0-3.254,0l-9.009,0a1.988,1.988,0,0,1-2.091-2.094q0-4.3,0-8.592a1.971,1.971,0,0,1,1.688-2c.155-.026.314-.024.492-.036,0-.071.009-.141.009-.211,0-.88,0-1.759,0-2.639a5.79,5.79,0,0,1,11.464-1.224,7.658,7.658,0,0,1,.117,1.241c.018.866.006,1.733.006,2.6C490.733,72.379,490.733,72.451,490.733,72.529Zm-2.15.011c.005-.063.013-.114.013-.165,0-.965.008-1.931-.008-2.9a3.653,3.653,0,0,0-7.3.162c0,.906,0,1.811,0,2.717,0,.063.006.125.008.182Z",
    transform: "translate(-476.958 -63.818)",
    fill: "#767983"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocker);
export default __webpack_public_path__ + "static/media/locker.361efb79.svg";
export { ForwardRef as ReactComponent };